export default __webpack_public_path__ + "static/media/group-3.7b5c23aa.png";